// extracted by mini-css-extract-plugin
module.exports = {"formTitle":"style_formTitle__3VCsA","formInfo":"style_formInfo__2d4rV","main-body":"style_main-body__1afZt","wapper":"style_wapper__3vT0S"};